import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Barcodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      uid: "",
      is_product_code: false,
      is_product_name: false,
      is_product_price: false,
      is_lot_number: false,
      paper_size: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
  }
  Get = async () => {
    loading(true);
    let [result] = await Promise.all([GET("admin/setting/barcodes/list", null)]);
    if (result?.status) {
      this.setState({
        ...result.data
      });
    }
    loading(false);
  };
  Update = async () => {
    const { uid,is_product_code, is_product_name, is_product_price, is_lot_number, paper_size } = this.state;

    loading(true);
    let body = {
      is_product_code,
      is_product_name,
      is_product_price,
      is_lot_number,
      paper_size,
    };

    let result = await PUT("admin/setting/barcodes/update/"+uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  render() {
    const { is_product_code, is_product_name, is_product_price, is_lot_number, paper_size } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="row">
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-6 mx-auto">
              <div className="rounded-4 bg-white p-3">
                <div className="d-flex justify-content-between">
                  <h4 className="fw-bold mb-3 me-3">ตั้งค่าบาร์โค้ด</h4>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6 d-flex mb-2">
                    <div className="wpx-150 mt-2">แสดงรหัสสินค้า</div>
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_product_code: e });
                      }}
                      checked={is_product_code}
                    />
                  </div>
                  <div className="col-12 col-md-6 d-flex mb-2">
                    <div className="wpx-150 mt-2">แสดงชื่อสินค้า</div>
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_product_name: e });
                      }}
                      checked={is_product_name}
                    />
                  </div>
                  <div className="col-12 col-md-6 d-flex mb-2">
                    <div className="wpx-150 mt-2">แสดงราคา</div>
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_product_price: e });
                      }}
                      checked={is_product_price}
                    />
                  </div>
                  <div className="col-12 col-md-6 d-flex mb-2">
                    <div className="wpx-150 mt-2">แสดง Serial Number</div>
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_lot_number: e });
                      }}
                      checked={is_lot_number}
                    />
                  </div>
                  <div className="d-flex mb-2">
                    <div className="wpx-150 mt-2">ขนาดกระดาษ</div>
                    <Select
                      className="form-control"
                      options={global.paper_size}
                      onChange={(e) => {
                        this.setState({ paper_size: e });
                      }}
                      value={this.state.paper_size}
                    ></Select>
                  </div>
                  <h4 className="fw-bold my-3">ตัวอย่างบาร์โค้ด</h4>
                  <div className="text-center my-5">
                    <h1 className="barcode" style={{fontSize:92, transform: "scaleY(2)",display: "inline-block",height:96}}>*124354635*</h1>
                    <div className="d-flex justify-content-center" style={{height:26}}>
                      {is_product_code && (<h4 className="mx-1">A2025060001 {is_product_price ? `100.00 บาท` : ""}</h4> )}
                    </div>
                    <div className="d-flex justify-content-center" style={{height:22}}>
                      {is_product_name && (<h4 className="mx-1">น็อต</h4>)}
                    </div>
                    <div className="d-flex justify-content-center" style={{height:22}}>
                      {is_lot_number && (<h5 className="mx-1">L2025060001</h5>)}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.Update();
                }}
              >
              บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
